export const NAME_MAX  = 100
export const QTY_MAX   = 9999
export const ITEMS_MAX = 50

/** Returns error string, or null if valid */
export function validateName(name) {
  const t = String(name ?? '').trim()
  if (t.length < 2)        return 'Укажите имя (минимум 2 символа)'
  if (t.length > NAME_MAX) return 'Имя слишком длинное'
  if (!/[а-яёА-ЯЁa-zA-Z]/.test(t)) return 'Имя должно содержать буквы'
  return null
}

/** Returns error string, or null if valid */
export function validatePhone(phone) {
  const raw    = String(phone ?? '').trim()
  if (!raw)               return 'Укажите телефон'
  const digits = raw.replace(/\D/g, '')
  if (digits.length < 10) return 'Слишком короткий номер — минимум 10 цифр'
  if (digits.length > 11) return 'Некорректный номер'
  if (digits.length === 11 && digits[0] !== '7' && digits[0] !== '8')
    return 'Номер должен начинаться с +7 или 8'
  return null
}

/** True if qty is a valid positive integer within allowed range */
export function isValidQty(qty) {
  const n = Number(qty)
  return Number.isInteger(n) && n >= 1 && n <= QTY_MAX
}

/** Validate the items array sent with an order */
export function validateItems(items) {
  if (!Array.isArray(items))             return 'Корзина пуста'
  if (items.length === 0)                return 'Корзина пуста'
  if (items.length > ITEMS_MAX)          return 'Слишком много позиций'
  for (const item of items) {
    if (typeof item.name  !== 'string' || item.name.trim().length   === 0 || item.name.length   > 200) return 'Некорректная позиция'
    if (typeof item.label !== 'string' || item.label.trim().length  === 0 || item.label.length  > 200) return 'Некорректная позиция'
    if (!isValidQty(item.qty)) return 'Некорректное количество'
    if (item.price         != null && (typeof item.price         !== 'number' || item.price         < 0)) return 'Некорректная цена'
    if (item.wholesalePrice != null && (typeof item.wholesalePrice !== 'number' || item.wholesalePrice < 0)) return 'Некорректная цена'
    if (item.wholesaleUnit  != null && (typeof item.wholesaleUnit  !== 'number' || item.wholesaleUnit  < 1)) return 'Некорректный размер упаковки'
  }
  return null
}
